import { AxiosResponse } from 'axios';
import { SET_SCREENS, SET_SCREEN, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_SCREEN_ISLOADING,
  DELETE_SCREEN,
  EDIT_SCREEN,
  GET_SCREEN,
  GET_SCREENS,
  GET_SCREENS_UNPOPULATED,
  REGISTER_SCREEN,
  UPDATE_SCREEN_LOCATION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Screen from '@/services/screen';
import { Module } from 'vuex';
import { EditScreen, RegisterScreen, GetScreen, UpdateScreenLocation } from '@/dtos/screen.dto';

const screen: Module<any, {}> = {
  state: {
    screen: {
      data: null,
      isLoading: false,
    },
    screens: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    screen: (state: { screen: any }) => state.screen,
    screens: (state: { screens: any }) => state.screens,
  },
  mutations: {
    [SET_SCREEN]: (
      state: { screen: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.screen.data = payload.data) : null,
        (state.screen.isLoading = payload.isLoading);
    },
    [SET_SCREENS]: (
      state: { screens: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.screens.data = payload.data) : null,
        (state.screens.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_SCREEN]: async ({ commit }: any, payload: FormData) => {
      commit(SET_SCREEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.registerScreen(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_SCREEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN, { isLoading: false });
        return false;
      }
    },
    [GET_SCREENS]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREENS, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.getScreens(
        payload as GetScreen
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREENS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREENS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREENS, { isLoading: false });
        return false;
      }
    },
    [GET_SCREENS_UNPOPULATED]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREENS, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.getScreensUnpopulated(
        payload as GetScreen
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREENS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREENS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREENS, { isLoading: false });
        return false;
      }
    },
    [GET_SCREEN]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.getScreens(
        payload as GetScreen
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_SCREEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN, { isLoading: false });
        return false;
      }
    },
    [EDIT_SCREEN]: async ({ commit }: any, payload: FormData) => {
      commit(SET_SCREEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.editScreen(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN, { isLoading: false });
        return false;
      }
    },
    [UPDATE_SCREEN_LOCATION]: async ({ commit }: any, payload: UpdateScreenLocation) => {
      commit(SET_SCREEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.updateScreenLocation(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN, { isLoading: false });
        return false;
      }
    },
    [DELETE_SCREEN]: async ({ commit }: any, payload: string) => {
      commit(SET_SCREEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Screen.deleteScreen(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN, { isLoading: false });
        return false;
      }
    },
    [CLEAR_SCREEN_ISLOADING]: ({ commit }) => {
      commit(SET_SCREEN, { isLoading: false });
      commit(SET_SCREENS, { isLoading: false });
    },
  },
};

export default screen;
